import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { OfferBulkActionsEffects } from './store/bulk-actions/bulk-actions.effects';
import { OfferBulkNamespace, OfferBulkReducer } from './store/bulk-actions/bulk-actions.store';
import { JobRequisitionsEffects } from './store/job-requisitions/job-requisitions.effects';
import {
  JobRequisitionsNamespace,
  JobRequisitionsReducer,
} from './store/job-requisitions/job-requisitions.store';
import { JobsGlobalEffects } from './store/jobs-coordinator.effects';
import { JobsBriefEffects } from './store/jobs/jobs-brief.effects';
import { JobsBriefANamespace, JobsBriefReducer } from './store/jobs/jobs-brief.store';
import { JobsFullEffects } from './store/jobs/jobs-full.effects';
import { JobsFullNamespace, JobsFullReducer } from './store/jobs/jobs-full.store';
import { JobsEffects } from './store/jobs/jobs.effects';
import { JobItemsNamespace, JobItemsReducer } from './store/jobs/jobs.store';
import { OfferLanguagesEffects } from './store/offer-languages/offer-languages.effects';
import {
  OfferLanguagesNamespace,
  OfferLanguagesReducer,
} from './store/offer-languages/offer-languages.store';
import { OffersByCompanyEffects } from './store/offers-by-company/offers-by-company.effects';
import {
  OffersByCompanyNamespace,
  OffersByCompanyReducer,
} from './store/offers-by-company/offers-by-company.store';
import { OffersGlobalEffects } from './store/offers-global.effects';
import { PipelineStagesEffects } from './store/pipeline-stages/pipeline-stages.effects';
import {
  PipelineStagesNamespace,
  PipelineStagesReducer,
} from './store/pipeline-stages/pipeline-stages.store';
import { PlacementsWithoutOpeningsEffects } from './store/placements-without-openings/placements-without-openings.effects';
import {
  PlacementsWithoutOpeningsNamespace,
  PlacementsWithoutOpeningsReducer,
} from './store/placements-without-openings/placements-without-openings.store';
import { StageNamespace, StageReducer } from './store/stages.store';
import { TalentPoolsGlobalEffects } from './store/talent-pools-coordinator.effects';
import { TalentPoolsBriefEffects } from './store/talent-pools/talent-pools-brief.effects';
import {
  TalentPoolsBriefNamespace,
  TalentPoolsBriefReducer,
} from './store/talent-pools/talent-pools-brief.store';
import { TalentPoolsFullEffects } from './store/talent-pools/talent-pools-full.effects';
import {
  TalentPoolsFullNamespace,
  TalentPoolsFullReducers,
} from './store/talent-pools/talent-pools-full.store';
import { TalentPoolsEffects } from './store/talent-pools/talent-pools.effects';
import {
  TalentPoolItemsNamespace,
  TalentPoolItemsReducer,
} from './store/talent-pools/talent-pools.store';

@NgModule({
  imports: [
    StoreModule.forFeature(JobItemsNamespace, JobItemsReducer),
    StoreModule.forFeature(JobsBriefANamespace, JobsBriefReducer),
    StoreModule.forFeature(TalentPoolItemsNamespace, TalentPoolItemsReducer),
    StoreModule.forFeature(TalentPoolsFullNamespace, TalentPoolsFullReducers),
    StoreModule.forFeature(TalentPoolsBriefNamespace, TalentPoolsBriefReducer),
    StoreModule.forFeature(JobsFullNamespace, JobsFullReducer),
    StoreModule.forFeature(OfferLanguagesNamespace, OfferLanguagesReducer),
    StoreModule.forFeature(OffersByCompanyNamespace, OffersByCompanyReducer),
    StoreModule.forFeature(PipelineStagesNamespace, PipelineStagesReducer),
    StoreModule.forFeature(StageNamespace, StageReducer),
    StoreModule.forFeature(OfferBulkNamespace, OfferBulkReducer),
    StoreModule.forFeature(JobRequisitionsNamespace, JobRequisitionsReducer),
    StoreModule.forFeature(PlacementsWithoutOpeningsNamespace, PlacementsWithoutOpeningsReducer),
    EffectsModule.forFeature([
      JobsEffects,
      JobsBriefEffects,
      JobsFullEffects,
      TalentPoolsEffects,
      TalentPoolsFullEffects,
      TalentPoolsBriefEffects,
      OfferLanguagesEffects,
      JobsGlobalEffects,
      TalentPoolsGlobalEffects,
      OffersByCompanyEffects,
      PipelineStagesEffects,
      OfferBulkActionsEffects,
      OffersGlobalEffects,
      JobRequisitionsEffects,
      PlacementsWithoutOpeningsEffects,
    ]),
  ],
})
export class OffersDataModule {}
